module.exports = __webpack_public_path__ + "static/media/06b.a8d793aa.webp";